import React, {useState} from 'react';
import {Trans} from 'react-i18next';
import Modal from 'react-bootstrap/Modal';

export default function UnSavedModal({
  showModal,
  setShowModal,
  handleLeave,
  handleCancel,
  type = 'leave',
}) {
  const handleCloseModal = () => {
    setShowModal(false);
    handleCancel && handleCancel();
  };
  return (
    <>
      <Modal show={showModal} backdrop="static" centered={true}>
        <Modal.Header>
          <Modal.Title>
            <Trans i18nKey="c.a.unsaved.prompt.title">
              You have unsaved changes on this page
            </Trans>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {type === 'theme' ? (
            <Trans i18nKey="c.a.change.theme.prompt.body">
              If you change this theme, all unsaved changes will be lost. Are
              you sure you want to change this page?
            </Trans>
          ) : (
            <Trans i18nKey="c.a.unsaved.prompt.body">
              If you leave this page, all unsaved changes will be lost. Are you
              sure you want to leave this page?
            </Trans>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-outline-secondary kt-margin-r-10"
            onClick={handleCloseModal}
          >
            <Trans i18nKey="c.a.unsaved.prompt.button.cancel">Cancel</Trans>
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleLeave}
          >
            {type === 'theme' ? (
              <Trans i18nKey="c.a.unsaved.prompt.button.change.theme">
                Change
              </Trans>
            ) : (
              <Trans i18nKey="c.a.unsaved.prompt.button.leave.page">
                Leave page
              </Trans>
            )}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
